import {jsonToCSV, readString} from "react-papaparse";

const EXCEL_EXTENSION = '.csv';

export default class CSVImportService {
  static readFile = async event =>
    new Promise((resolve, reject) => {
      try {
        const file = event.target.files[0];
        if (!file) {
          reject();
          return;
        }
        const reader = new FileReader();
        reader.onload = event => {
          try {
            this.parseExcel(event.target?.result, resolve);
          } catch (e) {
            console.error(e);
          }
        };
        reader.readAsText(file);
      } catch (e) {
        console.log(e);
      }
    });

  static parseExcel  (csv, resolve) {
    readString(csv, {
      complete: (results)=>{ resolve(results.data) },
      header:true
    });
  }
  static exportAsCSVFile(data) {
    const csv = jsonToCSV(data, {header:true});
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;

    link.download = `row_errors${new Date().getTime()}${EXCEL_EXTENSION}`;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }
}
